export default "__VITE_ASSET__cf7e7c0d__"